import React from "react";

import { useModulesSettings } from "./hooks/useModulesSettings";

import ModulesHeader from "./components/ModulesHeader";
import ModulesKpiCards from "./components/ModulesKpiCards";
import ModulesFiltersCard from "./components/ModulesFiltersCard";
import ModulesRoleGrid from "./components/ModulesRoleGrid";

export default function SettingsModules() {
  const dashboard = useModulesSettings();

  return (
    <div className="space-y-5">
      <ModulesHeader
        saving={dashboard.saving}
        refreshing={dashboard.refreshing}
        onRefresh={dashboard.fetchSettings}
        onSubmit={dashboard.handleSubmit}
      />

      <ModulesKpiCards
        loading={dashboard.loading}
        stats={dashboard.stats}
        filteredStats={dashboard.filteredStats}
      />

      <ModulesFiltersCard
        filters={dashboard.filters}
        setFilter={dashboard.setFilter}
        resetFilters={dashboard.resetFilters}
        loading={dashboard.loading}
        filteredCount={dashboard.filteredStats.total}
        totalCount={dashboard.stats.total}
      />

      <ModulesRoleGrid
        loading={dashboard.loading}
        saving={dashboard.saving}
        settings={dashboard.settings}
        filteredRoleDefs={dashboard.filteredRoleDefs}
        isEnabled={dashboard.isEnabled}
        onToggle={dashboard.toggleKey}
        onEnableRole={dashboard.enableRole}
        onDisableRole={dashboard.disableRole}
      />
    </div>
  );
}